import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { UPDATE_NAV_ITEM } from 'store/modules/statspro/career-and-season-stats/actions';
import { careerAndSeasonStatsNavSelector } from 'store/modules/statspro/career-and-season-stats/selectors';

export const useCareerAndSeasonStatsNavSync = (
    { competitions, seasons },
    competitionId,
    compseasonId
) => {
    const dispatch = useDispatch();
    const nav = useSelector(careerAndSeasonStatsNavSelector);

    /**
     * Set initial nav values
     */
    useEffect(() => {
        if (competitionId && !nav.competition.id) {
            dispatch(
                UPDATE_NAV_ITEM.request({
                    navItem: 'competition',
                    value: { id: competitionId }
                })
            );
        }

        if (compseasonId && !nav.season.id) {
            dispatch(
                UPDATE_NAV_ITEM.request({
                    navItem: 'season',
                    value: { id: compseasonId }
                })
            );
        }
    }, [competitions, seasons, competitionId]);
};
